import { useState } from 'react';
import StubGlow from '../ui/StubGlow';

const FOLDER_COLORS = { NPD: '#7c3aed', Legal: '#dc2626', Contracts: '#d97706', HR: '#ec4899', Suppliers: '#2563eb', 'Creative Assets': '#7c3aed', Campaigns: '#7c3aed', Financials: '#16a34a', Compliance: '#dc2626', Photography: '#ec4899', Packaging: '#d97706', Formulations: '#0891b2', Marketing: '#7c3aed', Operations: '#2563eb', Finance: '#16a34a', Team: '#d97706' };
const TYPE_COLORS = { pdf: '#dc2626', docx: '#2563eb', xlsx: '#16a34a', pptx: '#d97706', csv: '#0891b2', zip: '#64748b', jpg: '#7c3aed', png: '#7c3aed', mp4: '#111', mp3: '#d97706' };
const TYPE_ICONS = {
  pdf: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z',
  docx: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z',
  xlsx: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z',
  pptx: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z',
  csv: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z',
  zip: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z',
  folder: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z',
};

const TREE = [
  { name: 'NPD', color: '#7c3aed', children: [
    { name: 'CoCoFit RTD' }, { name: 'TwoLine' }, { name: 'Longevity Blend' },
  ]},
  { name: 'Legal', color: '#dc2626', children: [
    { name: 'Trademarks' }, { name: 'IP' }, { name: 'Regulatory' },
  ]},
  { name: 'Contracts', color: '#d97706', children: [
    { name: 'Supplier Agreements' }, { name: 'Partner Agreements' }, { name: 'NDAs' },
  ]},
  { name: 'HR', color: '#ec4899', children: [
    { name: 'Onboarding' }, { name: 'Policies' }, { name: 'Reviews' },
  ]},
  { name: 'Suppliers', color: '#2563eb', children: [
    { name: 'Phytotherapy' }, { name: 'Aptar' }, { name: 'Pacificomm' }, { name: 'Rohlig' },
  ]},
  { name: 'Creative Assets', color: '#7c3aed', children: [
    { name: 'Photography' }, { name: 'Video' }, { name: 'Graphics' }, { name: 'Brand Guidelines' },
  ]},
  { name: 'Campaigns', color: '#7c3aed', children: [
    { name: 'Meta' }, { name: 'Google' }, { name: 'TikTok' }, { name: 'Klaviyo' },
  ]},
  { name: 'Financials', color: '#16a34a', children: [
    { name: 'Invoices' }, { name: 'P&L Reports' }, { name: 'Budgets' }, { name: 'Tax' },
  ]},
  { name: 'Compliance', color: '#dc2626', children: [
    { name: 'FSVP' }, { name: 'TGA' }, { name: 'FDA' }, { name: 'SQF' },
  ]},
  { name: 'Packaging', color: '#d97706', children: [
    { name: 'Artwork' }, { name: 'Specs' }, { name: 'Quotes' },
  ]},
  { name: 'Formulations', color: '#0891b2', children: [
    { name: 'COAs' }, { name: 'Stability Reports' }, { name: 'Flavour Profiles' },
  ]},
];

const FILES = [
  { name: 'Creative Assets', type: 'folder', items: 24, category: 'Marketing' },
  { name: 'Campaigns', type: 'folder', items: 8, category: 'Marketing' },
  { name: 'Phytotherapy_Invoice_Mar2026.pdf', type: 'pdf', size: '1.2 MB', by: 'Mo', modified: '2d ago' },
  { name: 'OneLife_US_Launch_Deck_v4.pptx', type: 'pptx', size: '8.4 MB', by: 'Mo', modified: '1d ago' },
  { name: 'FON_Brand_Guidelines_2026.pdf', type: 'pdf', size: '14.2 MB', by: 'Eve', modified: '1w ago' },
  { name: 'Meta_Ads_Report_Q1_2026.xlsx', type: 'xlsx', size: '3.1 MB', by: 'Jade', modified: '3d ago' },
  { name: 'Ace_Onboarding_Package.zip', type: 'zip', size: '28.6 MB', by: 'Mo', modified: '5d ago' },
  { name: 'OneLife_Chocolate_HeroImage.jpg', type: 'jpg', size: '2.8 MB', by: 'Akaash', modified: '4d ago', isImage: true },
  { name: 'CoCoFit_RTD_FactorySpec.pdf', type: 'pdf', size: '4.7 MB', by: 'Renz', modified: '1w ago' },
  { name: 'Shopify_Export_April2026.csv', type: 'csv', size: '890 KB', by: 'Mo', modified: '1d ago' },
  { name: 'FSVP_Documentation_Primority.pdf', type: 'pdf', size: '2.1 MB', by: 'Mo', modified: '2w ago' },
  { name: 'Supplier_Contract_TheGoodFood.docx', type: 'docx', size: '156 KB', by: 'Mo', modified: '3w ago' },
  { name: 'OneFit_Gym_Promo_v2.mp4', type: 'mp4', size: '42.1 MB', by: 'Eve', modified: '6d ago' },
  { name: 'FON_P&L_March_2026.xlsx', type: 'xlsx', size: '1.8 MB', by: 'Mo', modified: '4d ago' },
  { name: 'Nathan_Cleary_Contract_v2.pdf', type: 'pdf', size: '340 KB', by: 'Mo', modified: '2w ago' },
  { name: 'OneLife_Vanilla_Flatlay.png', type: 'png', size: '5.2 MB', by: 'Akaash', modified: '3d ago', isImage: true },
  { name: 'Vitalus_COA_Batch_2204.pdf', type: 'pdf', size: '1.1 MB', by: 'Renz', modified: '1w ago' },
  { name: 'OneFit_Podcast_Clip.mp3', type: 'mp3', size: '8.9 MB', by: 'Jade', modified: '5d ago' },
  { name: 'Rohlig_Shipping_Quote_AU_US.pdf', type: 'pdf', size: '420 KB', by: 'Mo', modified: '1w ago' },
  { name: 'Team_OKRs_Q2_2026.docx', type: 'docx', size: '98 KB', by: 'Mo', modified: '2d ago' },
  { name: 'Investor Docs', type: 'folder', items: 6, category: 'Finance' },
  { name: 'TGA_Compliance_Checklist.xlsx', type: 'xlsx', size: '210 KB', by: 'Mo', modified: '3d ago' },
];

const GRADIENTS = [
  'linear-gradient(135deg,#7c3aed,#a78bfa)', 'linear-gradient(135deg,#2563eb,#60a5fa)',
  'linear-gradient(135deg,#0891b2,#22d3ee)', 'linear-gradient(135deg,#d97706,#fbbf24)',
];

export default function FilesTab() {
  const [viewMode, setViewMode] = useState('grid');
  const [expandedFolders, setExpandedFolders] = useState({ Marketing: true });
  const [selectedFile, setSelectedFile] = useState(null);
  const [search, setSearch] = useState('');
  const [dragover, setDragover] = useState(false);

  const filtered = FILES.filter(f => !search || f.name.toLowerCase().includes(search.toLowerCase()));

  function toggleFolder(name) { setExpandedFolders(p => ({ ...p, [name]: !p[name] })); }

  return (
    <div className="app-screen" style={{ background: '#f7f8fa' }}>
      <div style={{ display: 'flex', height: '100%' }}>
        {/* Left sidebar */}
        <div style={{ width: 220, flexShrink: 0, borderRight: '1px solid #e4e4e7', padding: '20px 0', overflowY: 'auto' }}>
          <div style={{ padding: '0 16px', marginBottom: 16 }}>
            <div style={{ fontSize: 10, fontWeight: 600, color: '#a1a1aa', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>Quick Access</div>
            {[{ icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z', label: 'Recent' },
              { icon: 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z', label: 'Starred' },
              { icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8z', label: 'Shared with me' },
            ].map(q => (
              <div key={q.label} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', borderRadius: 6, cursor: 'pointer', fontSize: 12, color: '#52525b' }}
                onMouseEnter={e => e.currentTarget.style.background = '#f4f4f5'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d={q.icon} /></svg>
                {q.label}
              </div>
            ))}
          </div>
          <div style={{ padding: '0 16px' }}>
            <div style={{ fontSize: 10, fontWeight: 600, color: '#a1a1aa', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>Folders</div>
            {TREE.map(folder => (
              <div key={folder.name}>
                <div onClick={() => toggleFolder(folder.name)} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 8px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 500, color: '#0a0a0a' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f4f4f5'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <span style={{ fontSize: 10, color: '#a1a1aa', transform: expandedFolders[folder.name] ? 'rotate(90deg)' : 'none', transition: 'transform 100ms', display: 'inline-block' }}>&#x25B6;</span>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill={folder.color} stroke="none"><path d={TYPE_ICONS.folder} /></svg>
                  {folder.name}
                </div>
                {expandedFolders[folder.name] && folder.children?.map(child => (
                  <div key={child.name} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '4px 8px 4px 32px', fontSize: 11, color: '#52525b', cursor: 'pointer', borderRadius: 6 }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f4f4f5'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill={folder.color} fillOpacity="0.3" stroke="none"><path d={TYPE_ICONS.folder} /></svg>
                    {child.name}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Main area */}
        <div style={{ flex: 1, overflow: 'auto', padding: '20px 24px', position: 'relative' }}
          onDragOver={e => { e.preventDefault(); setDragover(true); }} onDragLeave={() => setDragover(false)}
          onDrop={e => { e.preventDefault(); setDragover(false); }}>

          {/* Drag overlay */}
          {dragover && (
            <div style={{ position: 'absolute', inset: 0, zIndex: 10, border: '3px dashed #7c3aed', borderRadius: 16, background: 'rgba(124,58,237,0.04)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontSize: 16, fontWeight: 600, color: '#7c3aed' }}>Drop to upload to current folder</span>
            </div>
          )}

          {/* Top bar */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
            <div style={{ fontSize: 12, color: '#a1a1aa', flex: 'none' }}>
              <span style={{ cursor: 'pointer', color: '#7c3aed' }}>FON</span>
              <span> / </span>
              <span style={{ cursor: 'pointer', color: '#7c3aed' }}>Marketing</span>
              <span> / </span>
              <span style={{ color: '#0a0a0a', fontWeight: 500 }}>Creative Assets</span>
            </div>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search files..." style={{ flex: 1, padding: '7px 12px', fontSize: 12, border: '1px solid #e4e4e7', borderRadius: 8, fontFamily: 'inherit', color: '#0a0a0a', background: '#fff' }} />
            <div style={{ display: 'flex', gap: 2, background: '#f4f4f5', borderRadius: 6, padding: 2 }}>
              {['grid', 'list'].map(m => (
                <button key={m} onClick={() => setViewMode(m)} style={{ width: 28, height: 28, borderRadius: 4, border: 'none', cursor: 'pointer', background: viewMode === m ? '#fff' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: viewMode === m ? '0 1px 2px rgba(0,0,0,0.06)' : 'none' }}>
                  {m === 'grid' ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={viewMode === m ? '#0a0a0a' : '#a1a1aa'} strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /></svg>
                    : <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={viewMode === m ? '#0a0a0a' : '#a1a1aa'} strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></svg>}
                </button>
              ))}
            </div>
            <button style={{ padding: '7px 14px', fontSize: 12, fontWeight: 500, borderRadius: 8, border: '1px solid #e4e4e7', background: '#fff', color: '#52525b', cursor: 'pointer', fontFamily: 'inherit' }}>New Folder</button>
            <button style={{ padding: '7px 14px', fontSize: 12, fontWeight: 600, borderRadius: 8, border: 'none', background: '#7c3aed', color: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>Upload</button>
          </div>

          {/* Grid view */}
          {viewMode === 'grid' && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12 }}>
              {filtered.map((f, i) => (
                <StubGlow key={i}>
                  <div onClick={() => f.type !== 'folder' && setSelectedFile(f)} style={{ background: '#fff', border: '1px solid #e4e4e7', borderRadius: 12, overflow: 'hidden', cursor: 'pointer', transition: 'all 150ms' }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.06)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}>
                    <div style={{ height: 100, background: f.type === 'folder' ? `${FOLDER_COLORS[f.category] || '#64748b'}12` : f.isImage ? GRADIENTS[i % 4] : '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {f.type === 'folder' ? (
                        <svg width="36" height="36" viewBox="0 0 24 24" fill={FOLDER_COLORS[f.category] || '#64748b'} stroke="none"><path d={TYPE_ICONS.folder} /></svg>
                      ) : f.type === 'mp4' ? (
                        <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="#52525b"><polygon points="5 3 19 12 5 21 5 3" /></svg>
                        </div>
                      ) : (
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={TYPE_COLORS[f.type] || '#64748b'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d={TYPE_ICONS[f.type] || TYPE_ICONS.pdf} /><polyline points="14 2 14 8 20 8" />
                        </svg>
                      )}
                    </div>
                    <div style={{ padding: '10px 12px' }}>
                      <div style={{ fontSize: 12, fontWeight: 500, color: '#0a0a0a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</div>
                      <div style={{ fontSize: 10, color: '#a1a1aa', marginTop: 3 }}>
                        {f.type === 'folder' ? `${f.items} items` : f.size}
                        {f.by && <span> &middot; {f.by}</span>}
                      </div>
                    </div>
                  </div>
                </StubGlow>
              ))}
            </div>
          )}

          {/* List view */}
          {viewMode === 'list' && (
            <StubGlow>
              <div style={{ background: '#fff', border: '1px solid #e4e4e7', borderRadius: 12, overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                  <thead>
                    <tr>
                      {['Name', 'Modified', 'Modified by', 'Size'].map(h => (
                        <th key={h} style={{ textAlign: 'left', fontSize: 10, fontWeight: 500, color: '#a1a1aa', textTransform: 'uppercase', letterSpacing: '0.05em', padding: '10px 16px', borderBottom: '1px solid #f4f4f5' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((f, i) => (
                      <tr key={i} onClick={() => f.type !== 'folder' && setSelectedFile(f)} style={{ cursor: 'pointer' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#fafafa'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <td style={{ padding: '10px 16px', borderBottom: '1px solid #fafafa', display: 'flex', alignItems: 'center', gap: 8 }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill={f.type === 'folder' ? (FOLDER_COLORS[f.category] || '#64748b') : 'none'} stroke={f.type === 'folder' ? 'none' : (TYPE_COLORS[f.type] || '#64748b')} strokeWidth="1.5">
                            <path d={f.type === 'folder' ? TYPE_ICONS.folder : (TYPE_ICONS[f.type] || TYPE_ICONS.pdf)} />
                          </svg>
                          <span style={{ fontWeight: 500, color: '#0a0a0a' }}>{f.name}</span>
                          {f.type !== 'folder' && <span style={{ fontSize: 9, padding: '1px 5px', borderRadius: 4, background: `${TYPE_COLORS[f.type] || '#64748b'}15`, color: TYPE_COLORS[f.type] || '#64748b', fontWeight: 600, textTransform: 'uppercase' }}>{f.type}</span>}
                        </td>
                        <td style={{ padding: '10px 16px', borderBottom: '1px solid #fafafa', color: '#a1a1aa' }}>{f.modified || '--'}</td>
                        <td style={{ padding: '10px 16px', borderBottom: '1px solid #fafafa', color: '#52525b' }}>{f.by || '--'}</td>
                        <td style={{ padding: '10px 16px', borderBottom: '1px solid #fafafa', color: '#a1a1aa', fontVariantNumeric: 'tabular-nums' }}>{f.type === 'folder' ? `${f.items} items` : f.size}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </StubGlow>
          )}
        </div>
      </div>

      {/* File preview drawer */}
      {selectedFile && (<>
        <div onClick={() => setSelectedFile(null)} style={{ position: 'fixed', inset: 0, zIndex: 200, background: 'rgba(0,0,0,0.3)' }} />
        <aside style={{ position: 'fixed', top: 0, right: 0, bottom: 0, width: 560, maxWidth: '90vw', zIndex: 201, background: '#fff', boxShadow: '-8px 0 32px rgba(0,0,0,0.1)', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '16px 24px', borderBottom: '1px solid #e4e4e7', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#0a0a0a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{selectedFile.name}</div>
            <button onClick={() => setSelectedFile(null)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#a1a1aa', marginLeft: 8 }}>&times;</button>
          </div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            <StubGlow>
              <div style={{ height: 260, background: selectedFile.isImage ? GRADIENTS[0] : '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {selectedFile.type === 'mp4' ? (
                  <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="#52525b"><polygon points="5 3 19 12 5 21 5 3" /></svg>
                  </div>
                ) : selectedFile.isImage ? (
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5"><path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                ) : (
                  <div style={{ textAlign: 'center', color: '#a1a1aa' }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={TYPE_COLORS[selectedFile.type] || '#64748b'} strokeWidth="1.5" style={{ margin: '0 auto 8px' }}>
                      <path d={TYPE_ICONS.pdf} /><polyline points="14 2 14 8 20 8" fill="none" />
                    </svg>
                    <div style={{ fontSize: 11 }}>Preview unavailable</div>
                  </div>
                )}
              </div>
            </StubGlow>
            <div style={{ padding: '20px 24px' }}>
              <StubGlow>
                <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
                  <button style={{ padding: '7px 14px', fontSize: 11, fontWeight: 600, borderRadius: 8, border: 'none', background: '#7c3aed', color: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>Download</button>
                  <button style={{ padding: '7px 14px', fontSize: 11, fontWeight: 500, borderRadius: 8, border: '1px solid #e4e4e7', background: '#fff', color: '#52525b', cursor: 'pointer', fontFamily: 'inherit' }}>Share</button>
                  <button style={{ padding: '7px 14px', fontSize: 11, fontWeight: 500, borderRadius: 8, border: '1px solid #e4e4e7', background: '#fff', color: '#52525b', cursor: 'pointer', fontFamily: 'inherit' }}>Move</button>
                  <button style={{ padding: '7px 14px', fontSize: 11, fontWeight: 500, borderRadius: 8, border: '1px solid #e4e4e7', background: '#fff', color: '#dc2626', cursor: 'pointer', fontFamily: 'inherit', marginLeft: 'auto' }}>Delete</button>
                </div>
              </StubGlow>
              <StubGlow>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
                  {[
                    { label: 'Type', value: selectedFile.type.toUpperCase() },
                    { label: 'Size', value: selectedFile.size },
                    { label: 'Modified', value: selectedFile.modified },
                    { label: 'Modified by', value: selectedFile.by },
                  ].map(f => (
                    <div key={f.label} style={{ background: '#fafafa', borderRadius: 8, padding: '8px 12px' }}>
                      <div style={{ fontSize: 10, color: '#a1a1aa', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{f.label}</div>
                      <div style={{ fontSize: 13, fontWeight: 500, color: '#0a0a0a', marginTop: 2 }}>{f.value}</div>
                    </div>
                  ))}
                </div>
              </StubGlow>
              <div style={{ marginBottom: 20 }}>
                <div style={{ fontSize: 10, fontWeight: 500, color: '#a1a1aa', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>Version History</div>
                {['v2 — 2d ago by Mo', 'v1 — 1w ago by Eve'].map((v, i) => (
                  <div key={i} style={{ fontSize: 12, color: i === 0 ? '#0a0a0a' : '#a1a1aa', padding: '6px 0', borderBottom: '1px solid #fafafa', fontWeight: i === 0 ? 500 : 400 }}>
                    {v} {i === 0 && <span style={{ fontSize: 9, padding: '1px 5px', borderRadius: 4, background: '#f4f4f5', color: '#52525b', marginLeft: 4 }}>Current</span>}
                  </div>
                ))}
              </div>
              {/* Tags */}
              <div style={{ marginBottom: 20 }}>
                <div style={{ fontSize: 10, fontWeight: 500, color: '#a1a1aa', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>Tags</div>
                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                  {['Q1 2026', 'Supplier', 'Active'].map(t => <span key={t} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 999, background: '#f4f4f5', color: '#52525b' }}>{t}</span>)}
                  <button style={{ fontSize: 10, padding: '2px 8px', borderRadius: 999, border: '1px dashed #e4e4e7', background: 'transparent', color: '#a1a1aa', cursor: 'pointer', fontFamily: 'inherit' }}>+ Tag</button>
                </div>
              </div>

              {/* Sharing */}
              <div style={{ marginBottom: 20 }}>
                <div style={{ fontSize: 10, fontWeight: 500, color: '#a1a1aa', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>Sharing</div>
                <div style={{ background: '#fafafa', borderRadius: 8, padding: '10px 12px', marginBottom: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontSize: 12, color: '#0a0a0a' }}>Internal access</div>
                    <span style={{ fontSize: 10, color: '#52525b' }}>Mo (Owner), Team (View)</span>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button style={{ padding: '6px 12px', fontSize: 11, fontWeight: 500, borderRadius: 8, border: '1px solid #e4e4e7', background: '#fff', color: '#52525b', cursor: 'pointer', fontFamily: 'inherit' }}>Share internally</button>
                  <button style={{ padding: '6px 12px', fontSize: 11, fontWeight: 500, borderRadius: 8, border: '1px solid #7c3aed', background: '#fff', color: '#7c3aed', cursor: 'pointer', fontFamily: 'inherit' }}>Share externally</button>
                  <button style={{ padding: '6px 12px', fontSize: 11, fontWeight: 500, borderRadius: 8, border: '1px solid #e4e4e7', background: '#fff', color: '#52525b', cursor: 'pointer', fontFamily: 'inherit' }}>Copy link</button>
                </div>
              </div>

              <div>
                <div style={{ fontSize: 10, fontWeight: 500, color: '#a1a1aa', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>Comments</div>
                <div style={{ fontSize: 12, color: '#a1a1aa', textAlign: 'center', padding: 16 }}>No comments yet</div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <input placeholder="Add a comment..." style={{ flex: 1, padding: '7px 12px', fontSize: 12, border: '1px solid #e4e4e7', borderRadius: 8, fontFamily: 'inherit' }} />
                  <button style={{ padding: '7px 14px', fontSize: 11, fontWeight: 600, borderRadius: 8, border: 'none', background: '#7c3aed', color: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>Post</button>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </>)}
    </div>
  );
}
